<div class="smd-paginator">
  <div class="smd-paginator-range">
    <language key="DatatableRowsPerPage" defaultValue="Rows per page:"></language>
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-select [(ngModel)]="selectedRange">
        @for (range of ranges; track range) {
          <mat-option [value]="range">
            {{ range }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="smd-paginator-navigation">
    <div class="smd-paginator-buttons">
      <button (click)="onFirstClick($event)" [disabled]="currentPage == 1">
        <i class="material-icons">first_page</i>
      </button>
      <button (click)="onPreviousClick($event)" [disabled]="currentPage == 1">
        <i class="material-icons">keyboard_arrow_left</i>
      </button>
    </div>
    <div class="smd-paginator-current-page">
      <mat-form-field subscriptSizing="dynamic" appearance="outline">
        <input
          matInput
          [(ngModel)]="currentPage"
          type="number"
          min="1"
          max="{{ numPages }}"
          (keypress)="onPageKey($event)"
        />
      </mat-form-field>
      <language key="DatatableOf" defaultValue="of"></language>
      {{ numPages }}
    </div>
    <div class="smd-paginator-buttons">
      <button (click)="onNextClick($event)" [disabled]="currentPage == numPages">
        <i class="material-icons">keyboard_arrow_right</i>
      </button>
      <button (click)="onLastClick($event)" [disabled]="currentPage == numPages">
        <i class="material-icons">last_page</i>
      </button>
    </div>
  </div>
</div>
